import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StepTwoState } from "../types";

const initialState: StepTwoState = {
  skillsDistribution: null,
  totalQuestions: 0,
};

const stepTwoSlice = createSlice({
  name: "stepTwo",
  initialState,
  reducers: {
    updateSkillsDistribution: (state, action: PayloadAction<any>) => {
      state.skillsDistribution = action.payload;
    },
    addQuestion: (state, action) => {
      const { topicIndex, newQuestion } = action.payload;
      if (state.skillsDistribution && state.skillsDistribution.length) {
        state.skillsDistribution = state.skillsDistribution.map((topic, i) =>
          i === topicIndex
            ? {
                ...topic,
                questionTypes: [
                  ...topic.questionTypes,
                  {
                    questionType: newQuestion.questionType,
                    difficultyLevel: newQuestion.difficultyLevel,
                    numberOfQuestions: newQuestion.numberOfQuestions,
                    additionalRequirements: newQuestion.additionalRequirements,
                  },
                ],
              }
            : topic
        );
      }
    },
    updateQuestionProperty: (
      state,
      action: PayloadAction<{
        topicIndex: number;
        questionIndex: number;
        key: string;
        newValue: any;
      }>
    ) => {
      let { topicIndex, questionIndex, key, newValue } = action.payload;
      if (key === "numberOfQuestions") {
        const parsedValue = parseInt(newValue as string);
        newValue = isNaN(parsedValue) ? 0 : Math.max(0, parsedValue);
      }
      if (state.skillsDistribution && state.skillsDistribution.length) {
        state.skillsDistribution[topicIndex].questionTypes[questionIndex][key] =
          newValue;
      }
    },
    deleteQuestionType: (
      state,
      action: PayloadAction<{ topicIndex: number; questionIndex: number }>
    ) => {
      const { topicIndex, questionIndex } = action.payload;
      if (state.skillsDistribution && state.skillsDistribution.length) {
        state.skillsDistribution[topicIndex].questionTypes.splice(
          questionIndex,
          1
        );
      }
    },
    updateTotalQuestions: (state, action: PayloadAction<number>) => {
      state.totalQuestions = action.payload;
    },
    resetStepTwo: () => initialState,
  },
});

export const {
  updateSkillsDistribution,
  addQuestion,
  updateQuestionProperty,
  deleteQuestionType,
  updateTotalQuestions,
  resetStepTwo,
} = stepTwoSlice.actions;

export default stepTwoSlice.reducer;
